<template>
  <div class="wrap">
    <div class="search-page-wrap" v-if="permission">
      <div class="data-table-title white">ダイレクトメッセージ</div>

      <el-tabs v-model="activeName" class="tab-report">
        <el-tab-pane label="受信トレイ" name="inbox">
          <div class="setting-wrap" style="min-height:260px" v-loading="loading" v-if="loading"></div>
          <inbox v-if="activeName == 'inbox' && !loading && permission.access" @toConnectSetting="toConnectSetting" />
        </el-tab-pane>

        <el-tab-pane label="テンプレート" name="phrase">
          <phrase v-if="activeName == 'phrase' && permission.access" />
        </el-tab-pane>

        <el-tab-pane label="一斉送信リスト" name="bulk_history">
          <bulkHistory v-if="activeName == 'bulk_history' && permission.access" />
        </el-tab-pane>

        <el-tab-pane label="Instagramアカウント連携" name="connect">
          <connect v-if="activeName == 'connect' && permission.access" />
        </el-tab-pane>
      </el-tabs>

      <unpermitted v-if="!permission.access && !loading" />
    </div>
  </div>
</template>

<script>
import bulkHistory from "./bulk_history.vue";
import connect from "./connect.vue";
import inbox from "./inbox.vue";
import phrase from "./phrase.vue";
import unpermitted from "./../unpermitted";

export default {
  name: "message",
  components: {
    bulkHistory,
    connect,
    inbox,
    phrase,
    unpermitted,
  },
  data() {
    return {
      activeName: "inbox",
      requestId: 0,
      loading: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission.message;
    },
  },
  mounted() {
    this.query();
    this.$store.dispatch("changeActive", "message");
  },
  methods: {
    query() {
      this.loading = true;
      if (this.$route.query.activeName == null) {
        this.activeName = "inbox";
      } else {
        this.activeName = this.$route.query.activeName;
        this.$route.query.activeName = "";
      }
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    toConnectSetting() {
      this.activeName = "connect";
    },
  },
  watch: {
    $route() {
      if (this.$route.query.activeName=='phrase') {
        this.query()
      }
    },
    deep: true,
  },
  filters: {},
};
</script>
